import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Hàm lấy tên viết tắt chuẩn để gọi Logo VietQR
const getVietQRShortName = (bankName) => {
    if (!bankName) return "";
    const nameStr = bankName.toUpperCase().trim();
    
    if (nameStr.includes("VIETCOMBANK")) return "VCB";
    if (nameStr.includes("TECHCOMBANK")) return "TCB";
    if (nameStr.includes("VIETINBANK")) return "ICB";
    if (nameStr.includes("VPBANK")) return "VPB";
    if (nameStr.includes("KIENLONGBANK")) return "KLB";
    if (nameStr.includes("TPBANK")) return "TPB";
    if (nameStr.includes("MBBANK") || nameStr === "MB BANK" || nameStr === "MB") return "MB";
    if (nameStr.includes("AGRIBANK")) return "VBA";
    if (nameStr.includes("SACOMBANK")) return "STB";
    if (nameStr.includes("SEABANK")) return "SEAB";
    if (nameStr.includes("BIDV")) return "BIDV";
    if (nameStr.includes("OCB")) return "OCB";
    if (nameStr.includes("ACB")) return "ACB";
    if (nameStr.includes("HDBANK")) return "HDB";
    if (nameStr.includes("VIETCAPITALBANK")) return "VCCB";
    if (nameStr.includes("SCB")) return "SCB";
    if (nameStr.includes("VIB")) return "VIB";
    if (nameStr.includes("SHINHANBANK")) return "SHBVN"; 
    if (nameStr.includes("SHB") && !nameStr.includes("SHINHAN")) return "SHB"; 
    if (nameStr.includes("EXIMBANK")) return "EIB";
    if (nameStr.includes("MSB")) return "MSB";
    if (nameStr.includes("VIETTELMONEY")) return "VIETTELMONEY";
    if (nameStr.includes("MOMO")) return "momo";
    if (nameStr.includes("LPBANK")) return "LPB";
    
    return nameStr;
};

function AddMoney() {
    // ==== STATE TỪ CODE B (Giao diện) ====
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [bank, setBank] = useState(null); // Bank thủ công
    const [payment, setPayment] = useState([]);
    const [newMoney, setNewMoney] = useState(null);
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [activeTab, setActiveTab] = useState("truyentuyen");
    const [manualMethod, setManualMethod] = useState("bank"); 

    // ==== STATE TỪ CODE A (Chức năng) ====
    const [bankList, setBankList] = useState([]); // Bank tự động
    const [selectedBank, setSelectedBank] = useState(null);
    const [autoMethod, setAutoMethod] = useState('BANK'); 
    const [paymentUrl, setPaymentUrl] = useState(null);
    const initialBalanceRef = useRef(profile?.money || 0);
    const [myPromos, setMyPromos] = useState([]);

    const navigate = useNavigate();
    
    // Form nạp tiền chính
    const { register, handleSubmit, formState: { errors } } = useForm();
    // Form nạp giftcode
    const { register: registerGift, handleSubmit: handleGiftSubmit, reset: resetGift, setValue: setGiftValue } = useForm();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    const fetchData = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                if (JSON.stringify(profile) !== JSON.stringify(res.data.data)) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                    if (!paymentUrl) {
                        initialBalanceRef.current = res.data.data.money;
                    }
                }
            }).catch(() => localStorage.removeItem("user"));

        axios.get(`${process.env.REACT_APP_API_URL}/payment/paymentus`)
            .then((res) => {
                if (res.data.data) setPayment(res.data.data);
            }).catch(() => {});
    };

    const fetchMyPromos = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/promo/my-promo`, {})
            .then((res) => {
                if(res.data.success) {
                    const privatePromos = res.data.data.filter((promo) => {
                        return promo.type !== 'all' && promo.type !== 'chung' && promo.username !== 'all' && promo.username !== 'chung';
                    });
                    setMyPromos(privatePromos);
                }
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        fetchData();
        fetchMyPromos();

        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`)
            .then((res) => {
                if(res.data.data) {
                    setSetting(res.data.data[0]);
                    localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
                }
            });

        // Lấy danh sách ngân hàng Auto (từ Code A)
        axios.get(`${process.env.REACT_APP_API_URL}/bank/getBanks`)
            .then((res) => {
                if (res.data && res.data.success) {
                    setBankList(res.data.data);
                    if(res.data.data.length > 0) setSelectedBank(res.data.data[0].bankCode);
                }
            })
            .catch((err) => console.log(err));

        // Lấy danh sách ngân hàng thủ công (từ Code B)
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getbank`)
            .then((res) => setBank(res.data.data))
            .catch(() => setBank(null));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // POLLING KIỂM TRA TRẠNG THÁI NẠP TIỀN (Chức năng Code A)
    useEffect(() => {
        let interval;
        if (paymentUrl) {
            interval = setInterval(() => {
                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
                    .then((res) => {
                        if (res.data && res.data.data) {
                            const newProfile = res.data.data;
                            if (newProfile.money > initialBalanceRef.current) {
                                setProfile(newProfile);
                                localStorage.setItem("profile", JSON.stringify(newProfile));
                                
                                setPaymentUrl(null); 
                                swal("Thành Công", "Giao dịch nạp tiền đã hoàn tất!", "success").then(() => {
                                    navigate("/recharge_record");
                                });
                                
                                initialBalanceRef.current = newProfile.money;
                                clearInterval(interval);
                            }
                        }
                    })
                    .catch((err) => console.log(err));
            }, 5000); 
        }
        return () => { if (interval) clearInterval(interval); };
    }, [paymentUrl, navigate]);

    const handleCopyClick = (text) => {
        navigator.clipboard.writeText(text);
        swal("Thành công", "Copy thành công", "success");
    };

    // SUBMIT FORM NẠP TIỀN 
    const onSubmit = (data) => {
        if (load === true) return false;

        const inputPoint = Number(data.money?.replaceAll(".", "").replaceAll(",", "") || 0);
        const realMoney = inputPoint * 1000;

        if (inputPoint <= 0 || isNaN(inputPoint)) {
            return swal("Thông báo", "Vui lòng nhập số điểm hợp lệ", "error");
        }
        if (realMoney < setting?.minnap) {
            return swal("Chú ý", `Số điểm nạp tối thiểu là ${(setting?.minnap / 1000).toLocaleString("vi-VN")} Điểm`, "warning");
        }
        if (realMoney > setting?.maxnap) {
            return swal("Chú ý", `Số điểm nạp tối đa là ${(setting?.maxnap / 1000).toLocaleString("vi-VN")} Điểm`, "warning");
        }

        if (payment) {
            const count = payment.filter((obj) => obj.status_payment === "Pending" && obj.type_payment === "NẠP");
            if (count.length >= 15 && activeTab === "truyentuyen") {
                return swal("Thông báo", `Bạn đang có lệnh nạp tiền chưa xử lý. Vui lòng thanh toán hoặc chờ hệ thống.`, "error");
            } else if (count.length > 1 && activeTab === "thongthuong") {
                return swal("Thông báo", `Bạn đang có ${count.length} lệnh nạp điểm chưa xử lý, không thể tạo thêm lệnh.`, "error");
            }
        }

        setLoading(true);
        setLoad(true);

        // LOGIC NẠP TỰ ĐỘNG (Dùng chức năng Code A: Iframe, chọn Gate)
        if (activeTab === "truyentuyen") {
            let gateCode = "003";
            let typeName = "bank";
            let finalBankCode = null;

            if (autoMethod === 'BANK') {
                if (!selectedBank) {
                    setLoading(false); setLoad(false);
                    return swal("Thông báo", "Vui lòng chọn ngân hàng bạn muốn nạp", "error");
                }
                finalBankCode = selectedBank;
            } else if (autoMethod === 'MOMO') {
                gateCode = "004"; typeName = "momo";
            } else if (autoMethod === 'ZALOPAY') {
                gateCode = "005"; typeName = "zalopay";
            } else if (autoMethod === 'VIETTELPAY') {
                gateCode = "006"; typeName = "viettelmoney";
            }

            initialBalanceRef.current = profile?.money || 0;

            const payload = { 
                amount: realMoney,
                gate: gateCode,
                type: typeName,
                bankCode: finalBankCode
            };

            axios.post(`${process.env.REACT_APP_API_URL}/bank/createTrans`, payload)
                .then((res) => {
                    setLoading(false);
                    setLoad(false);
                    if (res.data.data && res.data.data.url) {
                        setPaymentUrl(res.data.data.url); // Mở iframe
                    } else {
                        swal("Lỗi", "Không nhận được liên kết thanh toán", "error");
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    setLoad(false);
                    swal("Thất bại", err.response?.data?.message || "Hệ thống nạp tiền đang bảo trì", "error");
                });
        } 
        // LOGIC NẠP THỦ CÔNG (Giữ nguyên của Code B)
        else {
            const formData = {
                money: realMoney,
                type_payment: "NẠP",
                detail: manualMethod,
                status_payment: "Pending",
                user: profile._id
            };
            axios.post(`${process.env.REACT_APP_API_URL}/payment/withDraw`, formData)
                .then((res) => {
                    swal("Nạp điểm thành công", "Điểm sẽ được cộng trong vòng 5 phút.", "success");
                    setLoading(false); setLoad(false);
                    navigate("/recharge_record");
                })
                .catch((err) => {
                    swal("Thất bại", err.response?.data?.message || "Đã có lỗi xảy ra", "error");
                    setLoad(false); setLoading(false);
                });
        }
    };

    // SUBMIT GIFTCODE (Từ Code A)
    const onSubmitGiftCode = (data) => {
        if (!data.code) return swal("Thông báo", "Vui lòng nhập mã nhận thưởng", "warning");
        
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/promo/active`, { code: data.code })
            .then((res) => {
                setLoading(false);
                swal("Thành Công", `Nhận thành công ${res.data.data.money.toLocaleString("vi-VN")}₫.`, "success");
                resetGift(); 
                setGiftValue("code", "");
                fetchData(); 
                fetchMyPromos(); 
            })
            .catch((err) => {
                setLoading(false);
                swal("Thất bại", err.response?.data?.message || "Đã xảy ra lỗi", "error");
            });
    };

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root { height: auto !important; min-height: 100vh; overflow-y: auto !important; background-color: #e3e1e2 !important; margin: 0; padding: 0; }
                .recharge-wrapper { padding-bottom: 100px; background-color: #e3e1e2; min-height: 100vh; }

                /* THÔNG TIN USER */
                .center-head { width: 100%; height: 180px; background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat; background-size: cover; padding: 0 20px; display: flex; align-items: center; color: #fff; box-shadow: 0 2px 5px rgba(0,0,0,0.2); }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-info p.email { margin: 0 0 6px 0; font-size: 13px; color: #ddd; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                .recharge-content { padding: 15px; }
                
                /* TABS */
                .r-tabs { display: flex; gap: 8px; margin-bottom: 10px; }
                .r-tab { flex: 1; padding: 12px; text-align: center; background: #fff; border-radius: 25px; font-size: 14px; font-weight: bold; color: #333; cursor: pointer; border: 1px solid #ddd; }
                .r-tab.active { background: #b71c1c; color: #fff; border-color: #b71c1c; box-shadow: 0 2px 4px rgba(0,0,0,0.2); }
                .r-list-label { background: #fff; padding: 12px; text-align: center; border-radius: 25px; font-weight: bold; color: #333; margin-bottom: 15px; border: 1px solid #ddd; cursor: pointer; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
                .r-list-label:active { background: #f0f0f0; }

                /* LƯỚI PHƯƠNG THỨC CHUNG (Sử dụng cho cả Tự động & Thủ công) */
                .method-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 20px; }
                .m-btn { background: #7a7a7a; color: #fff; padding: 10px 8px; border-radius: 4px; display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: bold; cursor: pointer; justify-content: flex-start; transition: 0.2s;}
                .m-btn.active { background: #b71c1c; }
                .m-icon { width: 24px; height: 24px; border-radius: 4px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; background: #fff;}
                .m-icon i { font-size: 13px; color: #fff; }
                .m-icon img { width: 16px; height: 16px; object-fit: contain; }
                
                /* SUB BANK GRID DÀNH CHO CODE A KHI CHỌN NGÂN HÀNG */
                .d-sub-bank-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 20px; }
                .d-sub-bank-item { background: #fff; border: 1px solid #ddd; border-radius: 6px; padding: 10px 5px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; cursor: pointer; transition: 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);}
                .d-sub-bank-item.active { border-color: #b71c1c; background: #fff5f5; box-shadow: 0 0 0 1px #b71c1c; }
                .d-sub-bank-item img { height: 24px; width: 100%; object-fit: contain; }
                .d-sub-bank-item span { font-size: 11px; font-weight: bold; color: #444; text-align: center; }

                .instruction-title { font-size: 14px; font-weight: bold; color: #444; margin-bottom: 10px; }

                /* KHUNG NGÂN HÀNG THỦ CÔNG */
                .bank-detail-card { background-color: #272a42; color: #fff; padding: 20px; border-radius: 8px; position: relative; margin-bottom: 20px; font-size: 14px; line-height: 1.8; box-shadow: 0 4px 6px rgba(0,0,0,0.2); }
                .qr-wrapper { background-color: #eaf3e5; padding: 10px; display: inline-block; border-radius: 4px; margin-bottom: 15px; }
                .bank-detail-card img { max-width: 140px; display: block; }
                .btn-copy-stk { position: absolute; top: 15px; right: 15px; background-color: #1a1e2d; color: #fff; border: 1px solid #444; padding: 4px 12px; border-radius: 4px; font-size: 12px; font-weight: bold; cursor: pointer; }
                .btn-copy-stk:active { background: #333; }
                .bank-text-row { margin-bottom: 5px; color: #ccc; }
                .bank-text-row b { color: #fff; font-weight: bold; font-size: 15px;}

                /* FORM NHẬP TIỀN & GIFTCODE */
                .form-box { background: #fff; padding: 15px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-bottom: 20px; }
                .input label { display: block; font-weight: bold; margin-bottom: 8px; color: #333; font-size: 14px; }
                .ipadd { width: 100%; padding: 12px 15px; border: 1px solid #ddd; border-radius: 5px; font-size: 15px; outline: none; }
                .ipadd:focus { border-color: #b71c1c; }
                .real-money-hint { display: block; margin-top: 6px; font-size: 13px; font-weight: bold; color: #00b459; margin-bottom: 15px;}
                .btn-submit { width: 100%; background: #b71c1c; color: #fff; font-weight: bold; padding: 14px; border: none; border-radius: 5px; font-size: 16px; cursor: pointer; }
                
                .huongdan { background: #fff; padding: 15px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); font-size: 13px; line-height: 1.6; color: #444; }
                .huongdan .title { font-size: 15px; color: #b71c1c; margin-bottom: 10px !important; font-weight: bold;}
                .huongdan ul { padding-left: 20px; margin: 0; }

                /* IFRAME CONTAINER NẠP TIỀN */
                .iframe-container { width: 100%; height: 600px; background: #fff; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 10px rgba(0,0,0,0.1); margin-bottom: 20px; }
                .iframe-container iframe { width: 100%; height: 100%; border: none; }
                .btn-close-iframe { width: 100%; background: #444; color: #fff; font-weight: bold; padding: 14px; border: none; border-radius: 5px; font-size: 16px; cursor: pointer; margin-bottom: 20px; }
                
                /* GIFTCODE LIST CÁ NHÂN */
                .promo-item { border: 1px solid #eee; border-radius: 6px; padding: 12px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; cursor: pointer; background: #f9f9f9; }
                .promo-code { font-weight: bold; color: #333; font-size: 14px; }
                .promo-money { color: #b71c1c; font-size: 12px; font-weight: bold; margin-top: 4px; }
                .promo-copy { background: #e3e1e2; color: #333; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: bold; border: none; cursor: pointer; }
            `}</style>

            <div className="recharge-wrapper">
                
                {/* 1. THÔNG TIN USER */}
                <div className="center-head">
                    <div className="profile-avatar-wrapper">
                        <div className="profile-avatar"><i className="fa-solid fa-user"></i></div>
                        <span className="profile-v1-badge">v1</span>
                    </div>
                    <div className="profile-info">
                        <h3>{profile?.username}</h3>
                        <div className="profile-stats">
                          <p>Mã mời : <span>{profile.code}</span></p>
                            <p>Số dư : <span>{profile?.money ? Math.floor(profile.money / 1000).toLocaleString("vi-VN") : "0"} Điểm</span></p>
                        </div>
                    </div>
                </div>

                <div className="recharge-content">
                    
                    {/* TABS & NÚT LỊCH SỬ */}
                    <div className="r-tabs">
                        <div className={`r-tab ${activeTab === "truyentuyen" ? "active" : ""}`} onClick={() => { setActiveTab("truyentuyen"); setPaymentUrl(null); }}>Nạp tự động</div>
                        <div className={`r-tab ${activeTab === "thongthuong" ? "active" : ""}`} onClick={() => { setActiveTab("thongthuong"); setPaymentUrl(null); }}>Nạp thủ công</div>
                    </div>
                    <div className="r-list-label" onClick={() => navigate("/recharge_record")}>
                        Lịch sử nạp điểm
                    </div>

                    {/* NẾU ĐANG TRONG QUÁ TRÌNH THANH TOÁN ONLINE (Hiển thị Iframe) */}
                    {paymentUrl ? (
                        <AnimatedPage>
                            <button className="btn-close-iframe" onClick={() => setPaymentUrl(null)}>Hủy thanh toán / Quay lại</button>
                            <div className="iframe-container">
                                <iframe src={paymentUrl} title="Payment Gateway" allowFullScreen></iframe>
                            </div>
                            <div className="huongdan">
                                <div className="title">Đang chờ xử lý...</div>
                                <ul>
                                    <li>Vui lòng quét mã QR hoặc chuyển khoản theo thông tin trong khung bên trên.</li>
                                    <li>Giữ nguyên trang này, hệ thống sẽ tự động cập nhật điểm ngay khi bạn chuyển khoản thành công.</li>
                                </ul>
                            </div>
                        </AnimatedPage>
                    ) : (
                        <>
                            {/* ==================================================== */}
                            {/* TAB NẠP TỰ ĐỘNG (Chức năng Code A hòa nhập UI Code B)*/}
                            {/* ==================================================== */}
                            {activeTab === "truyentuyen" && (
                                <AnimatedPage>
                                    <div className="instruction-title">Chọn phương thức nạp:</div>
                                    <div className="method-grid">
                                        <div className={`m-btn ${autoMethod === "BANK" ? "active" : ""}`} onClick={() => setAutoMethod("BANK")}>
                                            <div className="m-icon"><img src="https://cdn-icons-png.flaticon.com/512/2830/2830284.png" alt="Bank" /></div> Ngân hàng
                                        </div>
                                        <div className={`m-btn ${autoMethod === "MOMO" ? "active" : ""}`} onClick={() => setAutoMethod("MOMO")}>
                                            <div className="m-icon"><img src="https://cdn.haitrieu.com/wp-content/uploads/2022/10/Logo-MoMo-Square.png" alt="Momo" /></div> Momo
                                        </div>
                                        <div className={`m-btn ${autoMethod === "ZALOPAY" ? "active" : ""}`} onClick={() => setAutoMethod("ZALOPAY")}>
                                            <div className="m-icon"><img src="https://cdn.haitrieu.com/wp-content/uploads/2022/10/Logo-ZaloPay-Square.png" alt="ZaloPay" /></div> ZaloPay
                                        </div>
                                        <div className={`m-btn ${autoMethod === "VIETTELPAY" ? "active" : ""}`} onClick={() => setAutoMethod("VIETTELPAY")}>
                                            <div className="m-icon"><img src="https://brandlogos.net/wp-content/uploads/2021/10/ViettelPay-logo-1.png" alt="ViettelPay" /></div> ViettelPay
                                        </div>
                                        <div className={`m-btn ${autoMethod === "GIFTCODE" ? "active" : ""}`} onClick={() => setAutoMethod("GIFTCODE")}>
                                            <div className="m-icon"><i className="fa-solid fa-gift" style={{color: '#b71c1c'}}></i></div> Giftcode
                                        </div>
                                    </div>

                                    {/* Sub-grid chọn Bank con khi chọn Ngân hàng */}
                                    {autoMethod === 'BANK' && bankList.length > 0 && (
                                        <div className="d-sub-bank-grid">
                                            {bankList.map((bk, idx) => {
                                                const shortName = getVietQRShortName(bk.bankName);
                                                return (
                                                    <div key={idx} className={`d-sub-bank-item ${selectedBank === bk.bankCode ? 'active' : ''}`} onClick={() => setSelectedBank(bk.bankCode)}>
                                                        <img src={`https://api.vietqr.io/img/${shortName}.png`} alt={bk.bankName} onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/2830/2830284.png" }} />
                                                        <span>{bk.bankName}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    {/* Form nhập điểm (Cho Gateways) */}
                                    {autoMethod !== 'GIFTCODE' && (
                                        <form className="form-box" onSubmit={handleSubmit(onSubmit)}>
                                            <div className="input">
                                                <label>Nhập số điểm nạp <small style={{ color: "#888", fontWeight: "normal" }}><br/>(1 Điểm = 1.000 VNĐ)</small></label>
                                                <input
                                                    className="ipadd"
                                                    type="text"
                                                    value={newMoney || ""}
                                                    {...register("money")}
                                                    onClick={() => setNewMoney(null)}
                                                    onChange={(e) => {
                                                        const raw = e.target.value.replaceAll(".", "").replaceAll(",", "");
                                                        if (!isNaN(raw) && raw !== "") setNewMoney(Number(raw).toLocaleString("vi-VN"));
                                                        else setNewMoney("");
                                                    }}
                                                    placeholder="Nhập số điểm muốn nạp"
                                                />
                                            </div>
                                            <span className="real-money-hint">Thực nhận: {newMoney ? (Number(newMoney.replaceAll(".", "").replaceAll(",", "")) * 1000).toLocaleString("vi-VN") : "0"} VNĐ</span>
                                            {errors.money && <p style={{ color: "red", fontSize: "13px", marginTop: "-10px" }}>{errors.money.message}</p>}
                                            
                                            <button type="submit" className="btn-submit" disabled={load}>
                                                {load ? "Đang xử lý..." : "Xác nhận Thanh toán"}
                                            </button>
                                        </form>
                                    )}

                                    {/* Form nhập Giftcode */}
                                    {autoMethod === 'GIFTCODE' && (
                                        <>
                                            <form className="form-box" onSubmit={handleGiftSubmit(onSubmitGiftCode)}>
                                                <div className="input">
                                                    <label>Mã nhận thưởng</label>
                                                    <input type="text" className="ipadd" placeholder="Nhập mã giftcode" {...registerGift("code", { required: true })} />
                                                </div>
                                                <button type="submit" className="btn-submit" style={{marginTop: '15px'}}>Xác nhận mã</button>
                                            </form>

                                            <div className="form-box" style={{background: 'transparent', boxShadow: 'none', padding: '0'}}>
                                                <div className="instruction-title">🎁 Mã Dành Cho Bạn</div>
                                                {myPromos && myPromos.length > 0 ? (
                                                    myPromos.map((promo, key) => (
                                                        <div key={key} className="promo-item" onClick={() => setGiftValue("code", promo.code)}>
                                                            <div>
                                                                <div className="promo-code">{promo.code}</div>
                                                                <div className="promo-money">+{Math.floor(promo.money).toLocaleString("vi-VN")} VNĐ</div>
                                                            </div>
                                                            <button type="button" className="promo-copy" onClick={(e) => { e.stopPropagation(); handleCopyClick(promo.code); }}>Sao chép</button>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div style={{ textAlign: 'center', color: '#888', fontSize: '13px', background: '#fff', padding: '15px', borderRadius: '8px' }}>
                                                        Hiện tại không có mã nào dành riêng cho bạn.
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </AnimatedPage>
                            )}

                            {/* ==================================================== */}
                            {/* TAB NẠP THỦ CÔNG (Chức năng và Giao diện của Code B) */}
                            {/* ==================================================== */}
                            {activeTab === "thongthuong" && (
                                <AnimatedPage>
                                    <div className="instruction-title">Chọn phương thức chuyển:</div>
                                    <div className="method-grid">
                                        <div className={`m-btn ${manualMethod === "bank" ? "active" : ""}`} onClick={() => setManualMethod("bank")}>
                                            <div className="m-icon" style={{ backgroundColor: "#cc0000" }}><i className="fa-solid fa-building-columns"></i></div> Chuyển khoản
                                        </div>
                                        <div className={`m-btn ${manualMethod === "momo" ? "active" : ""}`} onClick={() => setManualMethod("momo")}>
                                            <div className="m-icon" style={{ backgroundColor: "#d82d8b" }}><i className="fa-solid fa-wallet"></i></div> MOMO
                                        </div>
                                        <div className={`m-btn ${manualMethod === "usdt" ? "active" : ""}`} onClick={() => setManualMethod("usdt")}>
                                            <div className="m-icon" style={{ backgroundColor: "#00a651" }}><i className="fa-brands fa-bitcoin"></i></div> USDT
                                        </div>
                                    </div>

                                    <div className="content_bank">
                                        {bank && bank.map((item) => {
                                            if (manualMethod === "momo" && item.isShow && item.name_bank.toLowerCase() === "momo") {
                                                return (
                                                    <div className="bank-detail-card" key={item._id}>
                                                        <button type="button" className="btn-copy-stk" onClick={() => handleCopyClick(item.stk)}>Copy</button>
                                                        {item?.qr && <div style={{ textAlign: "center" }}><div className="qr-wrapper"><img src={item?.qr} alt="QR Momo" /></div></div>}
                                                        <div className="bank-text-row">Số Momo: <b>{item.stk}</b></div>
                                                        <div className="bank-text-row">Người nhận: <b>{item.fullname}</b></div>
                                                        {profile?.username && <div className="bank-text-row">Nội dung chuyển: <b>{item.title} {profile?.username}</b></div>}
                                                    </div>
                                                );
                                            }
                                            if (manualMethod === "bank" && item.isShow && item.name_bank.toLowerCase() !== "momo" && item.name_bank.toLowerCase() !== "usdt") {
                                                return (
                                                    <div className="bank-detail-card" key={item._id}>
                                                        <button type="button" className="btn-copy-stk" onClick={() => handleCopyClick(item.stk)}>Copy</button>
                                                        {item?.qr && <div style={{ textAlign: "center" }}><div className="qr-wrapper"><img src={item?.qr} alt="QR Bank" /></div></div>}
                                                        <div className="bank-text-row">STK: <b>{item.stk}</b></div>
                                                        <div className="bank-text-row">Ngân hàng: <b>{item.name_bank}</b></div>
                                                        <div className="bank-text-row">Người nhận: <b>{item.fullname}</b></div>
                                                        {profile?.username && <div className="bank-text-row">Nội dung chuyển: <b>{item.title} {profile?.username}</b></div>}
                                                    </div>
                                                );
                                            }
                                            if (manualMethod === "usdt" && item.isShow && item.name_bank.toLowerCase() === "usdt") {
                                                return (
                                                    <div className="bank-detail-card" key={item._id}>
                                                        <button type="button" className="btn-copy-stk" onClick={() => handleCopyClick(item.stk)}>Copy</button>
                                                        {item?.qr && <div style={{ textAlign: "center" }}><div className="qr-wrapper"><img src={item?.qr} alt="QR USDT" /></div></div>}
                                                        <div className="bank-text-row">Địa chỉ ví: <b>{item.stk}</b></div>
                                                        <div className="bank-text-row">Mạng lưới: <b>{item.title}</b></div>
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })}
                                    </div>

                                    <form className="form-box" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="input">
                                            <label>Nhập số điểm nạp <small style={{ color: "#888", fontWeight: "normal" }}><br/>(1 Điểm = 1.000 VNĐ)</small></label>
                                            <input
                                                className="ipadd" type="text" value={newMoney || ""} {...register("money")}
                                                onClick={() => setNewMoney(null)}
                                                onChange={(e) => {
                                                    const raw = e.target.value.replaceAll(".", "").replaceAll(",", "");
                                                    if (!isNaN(raw) && raw !== "") setNewMoney(Number(raw).toLocaleString("vi-VN"));
                                                    else setNewMoney("");
                                                }}
                                                placeholder="Nhập số điểm muốn nạp"
                                            />
                                        </div>
                                        <span className="real-money-hint">Thực nhận: {newMoney ? (Number(newMoney.replaceAll(".", "").replaceAll(",", "")) * 1000).toLocaleString("vi-VN") : "0"} VNĐ</span>
                                        {errors.money && <p style={{ color: "red", fontSize: "13px", marginTop: "-10px" }}>{errors.money.message}</p>}
                                        <button type="submit" className="btn-submit" disabled={load}>{load ? "Đang xử lý..." : "Xác nhận Nạp Điểm"}</button>
                                    </form>
                                </AnimatedPage>
                            )}

                            {/* HƯỚNG DẪN CHUNG */}
                            <div className="huongdan">
                                <div className="title">Hướng dẫn nạp điểm</div>
                                {activeTab === "truyentuyen" ? (
                                    <ul>
                                        <li><b>Bước 1:</b> Chọn phương thức thanh toán online và nhập số điểm (1 điểm = 1.000 VNĐ).</li>
                                        <li><b>Bước 2:</b> Bấm Xác nhận. Hệ thống sẽ mở cổng thanh toán.</li>
                                        <li>Sau khi quét mã, điểm sẽ được cộng tự động vào tài khoản của bạn ngay lập tức.</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>Chuyển khoản đến đúng thông tin ngân hàng/Momo ở trên.</li>
                                        <li>Vui lòng ghi đúng nội dung chuyển khoản gồm có cả tên đăng nhập của bạn.</li>
                                        <li>Sau khi chuyển khoản thành công, điền <b>số điểm</b> vào ô nhập và bấm xác nhận.</li>
                                    </ul>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
            
            <Footer />
            
            {loading && (
                <div className="loading" style={{zIndex: 99999}}>
                    <div className="loader"></div>
                </div>
            )}
        </AnimatedPage>
    );
}

export default AddMoney;